export default function ReportIcon({color}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.375 7.6H20.325L14.25 1.66V6.5C14.25 7.16 14.7 7.6 15.375 7.6ZM15.375 9.8C13.4625 9.8 12 8.37 12 6.5V1H6.375C4.4625 1 3 2.43 3 4.3V19.7C3 21.57 4.4625 23 6.375 23H17.625C19.5375 23 21 21.57 21 19.7V9.8H15.375ZM8.625 7.6H9.75C10.425 7.6 10.875 8.04 10.875 8.7C10.875 9.36 10.425 9.8 9.75 9.8H8.625C7.95 9.8 7.5 9.36 7.5 8.7C7.5 8.04 7.95 7.6 8.625 7.6ZM16.275 13.76L13.6875 17.06C13.35 17.5 12.5625 17.61 12.1125 17.28C12.1125 17.28 12.1125 17.28 12 17.28L10.9875 16.4L9.525 18.27C9.1875 18.71 8.4 18.82 7.95 18.49C7.5 18.16 7.3875 17.39 7.725 16.95L9.975 14.2C10.2 13.98 10.425 13.87 10.7625 13.76C11.1 13.76 11.325 13.87 11.6625 14.09L12.675 14.97L14.5875 12.55C14.925 12.11 15.7125 12 16.1625 12.33C16.5 12.55 16.6125 13.32 16.275 13.76Z"
        fill={color}
      />
    </svg>
  );
}
